import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export const ConfirmDialog = ({ open, title, description, onClose }) => {
  return (
    <Dialog open={open}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => onClose(true)}>
          Yes
        </Button>
        <Button color="primary" onClick={() => onClose(false)}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};
